import React, {useEffect, useRef} from 'react'
import {AVISO_VENDA_SUSPENSA as A} from '../utils/vendaSuspensa.js'

// Mesmo visual do WebcamModal (backdrop + card escuro). a11y: role=dialog, foco no botão, Esc fecha.
export default function AvisoVendaSuspensa({onClose}) {
    const botao = useRef(null)
    useEffect(() => {
        const anterior = document.activeElement
        botao.current?.focus()
        const onKey = (e) => { if (e.key === 'Escape') onClose() }
        window.addEventListener('keydown', onKey)
        return () => {
            window.removeEventListener('keydown', onKey)
            anterior?.focus?.()
        }
    }, [onClose])
    const link = {color: '#93c5fd', textDecoration: 'underline'}
    return (
        <div className="modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="venda-suspensa-titulo"
             onClick={(e) => { if (e.target === e.currentTarget) onClose() }}
             style={{zIndex: 999999, position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16}}>
            <div className="modal-card" style={{width: '100%', maxWidth: 420, background: '#020617', color: '#fff', borderRadius: 16, padding: 20, boxShadow: '0 20px 45px rgba(0,0,0,0.6)', border: '1px solid rgba(148,163,184,0.2)'}}>
                <h2 id="venda-suspensa-titulo" style={{margin: '0 0 12px', fontSize: 18, fontWeight: 600}}>{A.titulo}</h2>
                <p style={{margin: '0 0 8px', fontSize: 15}}>
                    {A.contato} <a style={link} href={A.hrefEmail}>{A.email}</a>, telefone{' '}
                    <a style={link} href={A.hrefTelefone}>{A.telefone}</a> ou WhatsApp{' '}
                    <a style={link} href={A.hrefWhatsapp} target="_blank" rel="noopener noreferrer">{A.whatsapp}</a>.
                </p>
                <p style={{margin: '0 0 16px', fontSize: 15}}>{A.horario}</p>
                <button ref={botao} type="button" onClick={onClose}
                        style={{width: '100%', padding: '10px 0', borderRadius: 8, border: 0, background: '#1d4ed8', color: '#fff', fontSize: 16}}>
                    Fechar
                </button>
            </div>
        </div>
    )
}
